
jQuery(function($){ 
  url = window.location.href;
  // if(url.search(/\/jp\//) !== -1) {
  //   langUrl = url.replace('/jp/', '/en/');
  //   $('p#language a').attr('href', langUrl);
  // } else
  // if (url.search(/\/en\//) !== -1) {
  //   langUrl = url.replace('/en/', '');
  //   $('p#language a').attr('href', langUrl);
  // } else {

  // }
  // if (url.search(/\/en\//) !== -1) {
  //   $('.is-ja').attr('onclick', "location.href='a'");
  //   console.log('124r1dhu');
  // } else {
  //   $('.is-en').attr('onclick', 'https://www.chatwork.com/#!rid264978246');
  //   console.log('PPPPPPPPP');
  // }

  // console.log(location.pathname.split('/')[0]);
  // console.log(location.pathname.split('/')[1]);
  // console.log(location.pathname.split('/')[2]);
});


